import axios from "axios";
import config from "../../../config";
import {
  CreateEmailIngestionRequest,
  CreateSftpIngestionRequest,
  EmailIngestion,
  FileShareSummary,
  SftpIngestion,
  UpdateEmailIngestionRequest,
  UpdateSftpIngestionRequest,
} from "../types";

const apiUrl = config.api;

export const listSftpIngestions = async (
  clientId: number,
): Promise<SftpIngestion[]> => {
  const response = await axios.get<SftpIngestion[]>(
    `${apiUrl}/ingestion/sftp`,
    { params: { clientId } },
  );

  return response.data;
};

export const createSftpIngestion = async (
  body: CreateSftpIngestionRequest,
): Promise<SftpIngestion> => {
  const response = await axios.post<SftpIngestion>(
    `${apiUrl}/ingestion/sftp`,
    body,
  );

  return response.data;
};

export const updateSftpIngestion = async (
  id: number,
  body: UpdateSftpIngestionRequest,
): Promise<void> => {
  await axios.put(`${apiUrl}/ingestion/sftp/${id}`, body);
};

export const deleteSftpIngestion = async (id: number): Promise<void> => {
  await axios.delete(`${apiUrl}/ingestion/sftp/${id}`);
};

export const listEmailIngestions = async (
  clientId: number,
): Promise<EmailIngestion[]> => {
  const response = await axios.get<EmailIngestion[]>(
    `${apiUrl}/ingestion/email`,
    { params: { clientId } },
  );

  return response.data;
};

export const createEmailIngestion = async (
  body: CreateEmailIngestionRequest,
): Promise<EmailIngestion> => {
  const response = await axios.post<EmailIngestion>(
    `${apiUrl}/ingestion/email`,
    body,
  );

  return response.data;
};

export const updateEmailIngestion = async (
  id: number,
  body: UpdateEmailIngestionRequest,
): Promise<void> => {
  await axios.put(`${apiUrl}/ingestion/email/${id}`, body);
};

export const deleteEmailIngestion = async (id: number): Promise<void> => {
  await axios.delete(`${apiUrl}/ingestion/email/${id}`);
};

export const listFileShares = async (): Promise<FileShareSummary[]> => {
  const response = await axios.get<FileShareSummary[]>(
    `${apiUrl}/ingestion/file-shares`,
  );

  return response.data;
};
